onComplete(function() {
	const medewerkers = document.querySelectorAll('.medewerker.aos-init');
	if (medewerkers) {
		let delay = 300;
		for (let i = 0; i < medewerkers.length; i ++) {
			medewerkers[i].setAttribute('data-aos-delay', delay);
			delay += 300;
		}
	}

	AOS.init();
});